import { Table, TableBody} from "@mui/material";
import LoadingWrapper from "../../../components/LoadingWraper";
import { SectionWrapper } from "../../../components/tableComponents";
import { TRawData } from "../../../types/cosmosApi"
import TxRow from "./TxRow";

type props = {
    rawData?: TRawData[],
    isLoading: boolean, 
    error: unknown | undefined,
    address: string,
    isSuccess: boolean
}


const TxSection = ({rawData, isLoading, error, address, isSuccess}: props) => {

    const parsedTx: TRawData[] | undefined = rawData?.reduce((txs: TRawData[] , tx) => {
        const isTxAlreadyExist = txs.find((t) => t.hash === tx.hash);
        if(!!!isTxAlreadyExist){
            txs.push(tx);
            txs.sort((a,b) => Number(a.createdAt) - Number(b.createdAt))
        }
        return txs;
    }, []);


    return (
        <div>
            <h4>Transactions: </h4>
            <LoadingWrapper
                child={
                    <SectionWrapper>
                        <Table  aria-label="overview snapshot table">
                            <TableBody>
                                {parsedTx?.map(
                                    (crd: TRawData) => {
                                        return <TxRow tx={crd} key={crd.hash} isCreator={address === crd.creator}/>
                                }
                            )}
                            </TableBody>
                        </Table>
                    </SectionWrapper>
                }
                isLoading = {isLoading }
                error = {!!error}
                isSucceeded={isSuccess}
                errorTxt = {`Could not found any transaction of ${address}`}
            />
        </div>
    )
}

export default TxSection